function AccountModals(){
	var $body = $('body');
	$('.account-guest .sign-in').click(function(){
		$body.removeClass('search-visible');
		$body.removeClass('show-menu');		
		if($body.hasClass('signup-visible')){
			$body.removeClass('signup-visible')
			setTimeout(function(){				
				$body.addClass('signin-visible');	
			},800);
		}else{
			$body.toggleClass('signin-visible');	
		}		
		return false; 
	});
	$('.account-guest .sign-up,.sign-in .block-right a').click(function(){
		$body.removeClass('search-visible');
		$body.removeClass('show-menu');
		if($body.hasClass('signin-visible')){
			$body.removeClass('signin-visible')
			setTimeout(function(){
				$body.addClass('signup-visible');	
			},800);
		}else{
			$body.toggleClass('signup-visible');	
		}		
		return false;
	});
	$('.signIn-up-overlay,.register-modal .btn-close,.login-modal .btn-close').click(function(){
		$body.removeClass('signin-visible');
		$body.removeClass('signup-visible');
	});
}

  